import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const HardSkillsBlock = styled(motion.div)`
  background-color: white;
`;

export const SkillsContainer = styled.div`
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 50px;
  width: 1200px;
  display: flex;
  justify-content: space-around;

  `;

export const Describe = styled(motion.div)`
  width: 500px;
  font-family: "Bitter",serif;
`;

export const Title = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  font-size: 27px;
`;

export const Paragraph = styled.p`
margin: 0;
font-family: "Bitter",serif;
`;

export const ListHardSkills = styled(motion.div)`
  font-family: "Bitter",serif;
`;

export const TitleHardSkills = styled.h3`
  margin: 0;
  font-size: 25px;
`;

export const SkillsUl = styled.ul`
margin: 0;
padding: 0;
margin-top: 15px;
width: 200px;
display: flex;
flex-wrap: wrap;
font-family: "Bitter",serif;
`;

export const SkillsLi = styled.li`
margin: 0;
margin: 5px 10px 5px 0px;
padding: 5px;
border: 2px solid black;
font-size: 17px;
cursor: default;

&:hover {
  background-color: black;
  color: white;
}
`;


